/** Responsibility: the initial page of events, before the socket takes over. */
import { useQuery } from '@tanstack/react-query';
import { hubApi } from '../client';

export function useEvents(limit = 100) {
  return useQuery({ queryKey: ['events', limit], queryFn: () => hubApi.listEvents(limit) });
}
